import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import color from "@definitions/mui/color";
import CloseIcon from "@icons/Close";
import Text from "../Text";
import { DialogHeader, DialogCloseButton, DialogBody } from "./styles";
import { IPopupForm } from "./contants";

const DialogForm = (props: IPopupForm) => {
  const {
    messages,
    maxWidth,
    image,
    fullScreen,
    isOpen,
    setIsOpen,
    children,
    customClose,
    className,
    ...rest
  } = props;

  const _handleOnClose = () => {
    if (customClose) {
      customClose();
    }
    setIsOpen(false);
  };

  const _renderImage = () => {
    const children = image;
    return (
      <Box mb={2} textAlign="center">
        {children}
      </Box>
    );
  };

  const _renderMessages = () => {
    return (
      <div>
        {messages?.map((message: string[], key: number) => {
          const content = message[0];
          const colorMUI = message[1] === "light" ? color.general.mid : color.general.main;
          const fontWeight = message[2] || "500";
          const isTitle = message[3] === "title";
          const alignText = message[4] === "center" || !message[4] ? "center" : "start";

          return (
            <Box key={key} mb={3}>
              <Text variant={isTitle ? "h2" : "body1"}>
                <Box
                  sx={{ color: colorMUI }}
                  fontSize={isTitle ? "24px" : "16px"}
                  fontWeight={fontWeight}
                  textAlign={alignText}
                >
                  {content}
                </Box>
              </Text>
            </Box>
          );
        })}
      </div>
    );
  };

  const _renderChildren = () => {
    return <Box mb={2}>{children}</Box>;
  };

  return (
    <Dialog
      open={!isOpen ? false : true}
      fullWidth
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      scroll="body"
      {...rest}
      className={className}
    >
      <Box css={DialogHeader}>
        <IconButton css={DialogCloseButton} onClick={_handleOnClose} size="large">
          <CloseIcon style={{ height: 16, width: 16 }} />
        </IconButton>
      </Box>
      <Box css={DialogBody}>
        {_renderImage()}
        {_renderMessages()}
        {_renderChildren()}
      </Box>
    </Dialog>
  );
};

export default DialogForm;
